import { render, staticRenderFns } from "./12ManifestValuation.vue?vue&type=template&id=137be668&"
import script from "./12ManifestValuation.vue?vue&type=script&lang=js&"
export * from "./12ManifestValuation.vue?vue&type=script&lang=js&"
import style0 from "./12ManifestValuation.vue?vue&type=style&index=0&id=137be668&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports